module.exports = __webpack_public_path__ + "img/top1.2e5cc3eb.svg";